<template>
  <header><h1>Welcome back!</h1>
    <p>
      Log in to manage your shifts and support your organisation.
    </p>
  </header>
  <div>
    <form @submit.prevent="login">
      <div class="form-group mb-3">
        <label for="username" class="form-label">Username</label>
        <input v-model="username" id="username" type="text" class="form-control" required autocomplete="username"
               @input="resetError" ref="usernameInput" placeholder="Enter your username">
      </div>
      <div class="form-group mb-3">
        <label for="password" class="form-label">Password</label>
        <input v-model="password" id="password" type="password" class="form-control" required
               autocomplete="current-password" placeholder="Enter your password"
               @input="resetError">
      </div>
      <div class="form-group mb-3">
        <button type="submit" class="btn btn-primary">Login</button>
      </div>
    </form>
    <p v-if="error" class="alert alert-danger">{{ error }}</p>
  </div>
  <div class="text-center mt-5">
    <button type="button" class="btn btn-secondary me-3" @click="$router.push('/reset-password')">Forgot your
      password?
    </button>
    <button type="button" class="btn btn-secondary" @click="$router.push('/register')">No account yet?</button>
  </div>
</template>

<script>
import {useAuthStore} from '@/store/auth'

function getCSRFToken() {
  const name = 'csrftoken';
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [key, value] = cookie.trim().split('=');
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return '';
}

export default {
  setup() {
    const authStore = useAuthStore()
    return {
      authStore
    }
  },
  data() {
    return {
      username: "",
      password: "",
      error: ""
    }
  },
  mounted() {
    this.$refs.usernameInput.focus();
  },
  methods: {
    async login() {
      try {
        const csrfToken = getCSRFToken();
        await this.authStore.login(this.username, this.password, this.$router, csrfToken)
        if (!this.authStore.isAuthenticated) {
          this.error = 'Login failed. Please check your credentials.' // TODO: display "check validation mail" if not yet validated
        }
      } catch (error) {
        console.error(error)
        this.error = 'Login failed. Please check your credentials.'
      }
    },
    resetError() {
      this.error = ""
    }
  }
}
</script>
